var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyWorkNestPurpleNegativeRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 933.02 169.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#7a5cf0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.63,502l-39.37,90.68h-6.51l-27.81-59.07-27.82,59.07h-6.5L303.24,502h20.23l23.3,58,26.91-60h6.51l27.27,59.25L430.4,502Z",
    transform: "translate(-73.49 -455.16)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493.05,500c25.83-.54,47.69,21.14,47.15,46.24.54,25.11-21.32,47-47.15,46.43-25.47.54-47.32-21.32-46.78-46.43C445.73,520.73,467.58,499.6,493.05,500Zm.18,17.34c-15.71,0-27.63,12.65-27.63,29.08s11.92,28.72,27.45,28.72c15.72,0,27.64-12.64,27.64-28.72C520.69,530,508.59,517.3,493.23,517.3Z",
    transform: "translate(-73.49 -455.16)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.07,518.75h-5.78c-15,0-26,8.85-26,24.56v47.33h-19V502H567v11.56A32.81,32.81,0,0,1,592.85,501a29.37,29.37,0,0,1,7.22.91Z",
    transform: "translate(-73.49 -455.16)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M608.08,455.16h19V590.64h-19Zm80.75,135.48H666.07l-38.48-49.86L662.27,502h23.49L650,541Z",
    transform: "translate(-73.49 -455.16)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M798.4,552.53c2.34,14.45,13.72,23.3,28.9,23.3,9.21,0,17.88-3.43,25.83-10.48l9,13c-10.12,9.57-21.86,14.27-35.4,14.27-27.1,0-47.69-20-47.69-46.25-.54-25.47,20.77-47,45.88-46.42,23.48,0,41,17.52,41,40.64a56.71,56.71,0,0,1-1.44,11.93ZM847,537.71c-.18-13.54-10.3-21.67-22.76-21.67s-22.58,8.49-25.47,21.67Z",
    transform: "translate(-73.49 -455.16)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.87,563.54c7.76,8.13,15.53,12.65,24.92,12.65,8.13,0,14.28-3.43,14.28-9.94,0-5.23-3.8-7.4-12.47-11l-9-3.79c-15.72-6.5-23.12-13.37-23.12-25.83,0-15.9,13.18-25.65,31.25-25.65,12.82,0,22.94,4.52,30.71,13.73l-10.3,11.74a28.9,28.9,0,0,0-20.77-9c-7.41,0-12.11,2.89-12.11,8.49,0,4.51,3.08,6.86,11.75,10.48l8.49,3.43c16.79,7,24.2,14.27,24.2,26.73,0,8.49-3.07,15.18-9.39,20.05-6.32,4.7-14.09,7-23.49,7A44.56,44.56,0,0,1,870,575.47Z",
    transform: "translate(-73.49 -455.16)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1006.51,590.64a78,78,0,0,1-15.72,2c-20.41,0-32.69-10.12-32.69-30.89V518.39H943.65V502H958.1v-23.3h19.15V502h26.37v16.44H977.25v41.72c0,11.38,6,15.36,17.52,15.36,2.71,0,6.5-.37,11.74-.91Z",
    transform: "translate(-73.49 -455.16)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 660.03,
    cy: 26.19,
    r: 17.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.52,502.42c-21.28,0-38.6,18.75-38.6,41.81v46.41h18.67V543.87c0-11.84,8.94-21.48,19.93-21.48s19.92,9.64,19.92,21.48v46.77h18.67V544.23C772.11,521.17,754.8,502.42,733.52,502.42Z",
    transform: "translate(-73.49 -455.16)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.91,590.48h-9.23V536.05c0-15.74-8.68-26.22-23.14-26.22-14.65,0-25.32,11.21-25.32,24.77v55.88h-9V536.05c0-15.74-8.86-26.22-23.33-26.22-15,0-25.32,11-25.32,26.22v54.43h-9V503.13h8.68v11.4c5.79-8.5,15.37-13.2,27-13.2,13.56,0,23,6.33,27.48,17,5.79-10.12,16.28-17,30.2-17,19.53,0,31.11,13.56,31.11,34Z",
    transform: "translate(-73.49 -455.16)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.47,503.13,250.89,604.76c-6.33,14.29-14.83,20.08-27.31,20.08a47,47,0,0,1-12.29-1.63v-8a47.68,47.68,0,0,0,11,1.27c9.22,0,15.73-4,20.25-15l5.61-12.84-37.44-85.54h9.95l32.37,75.23,31.64-75.23Z",
    transform: "translate(-73.49 -455.16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWorkNestPurpleNegativeRgb);
export default __webpack_public_path__ + "static/media/myWorkNest_Purple_Negative_RGB.6cf39931.svg";
export { ForwardRef as ReactComponent };